import { put, takeLatest, call, spawn } from 'redux-saga/effects';
import { positionActions } from '../../../application/actions/position';

import api from '../../api';

const apiPosition = api(process.env.REACT_APP_POSITION_API);

export function* fetchPosition() {
  try {
    const { data } = yield call(apiPosition.get, 'v1/consultar');

    if (data) yield put(positionActions.fetchPositionSuccess({ position: data.cargos }));
    else yield put(positionActions.fetchPositionError());
  } catch (err) {
    yield put(positionActions.fetchPositionError());
  }
}

export function* watchFetchPosition() {
  yield takeLatest(positionActions.fetchPosition.type, fetchPosition);
}

export default function* positionSaga() {
  yield spawn(watchFetchPosition);
}
